@if(isLoading()){
<search-loading-placeholder></search-loading-placeholder>
}@else{
<p [innerHtml]="text"></p>

<p class="app__form--attribute--title font-normal text-sm leading-6 text-[#18191C]">
  <span>
    {{ subText }}
  </span>
</p>
@if(currentType?.title == 'Suggestions'){
<mynetwork-suggestions [isFromNetworkSetup]="true" (moveToNextStepEmitter)="moveToNextStepEmitter.emit()"></mynetwork-suggestions>
}@else{
<div class="flex flex-col gap-6">
  <app-connected-user-card
    style="height: 100%; max-height: 100%; display: block; width: 99%"
    [isFromNetworkRequest]="true"
    [user]="currentUser"
    [relationshipType]="relationshipType"
    [networkRequestFilteredList]="filteredList"
    (handleConnectionsExistingEmitter)="handleConnectionsExisting($event)"
    (handleConnectCheckEmitter)="handleConnection($event)"
    (relationShipCountEmitter)="handleRelationShipCount($event)"
    (relationshipListEmitter)="handlerRelationshipList($event)"
    (allRelationshipListEmitter)="handlerAllRelationshipList($event)"
    [showCheckBox]="false"
  ></app-connected-user-card>
  @if(currentType?.title == 'Family Users'){
  <mynetwork-suggestions [isFromNetworkSetup]="true" [hideHeaderAndControls]="true" (moveToNextStepEmitter)="moveToNextStepEmitter.emit()"></mynetwork-suggestions>
  }
</div>
}}
